'use client';
import { Link } from 'react-router-dom'
import Image from '@/components/Image'
import PathinSocialIcons from '@/components/PathinSocialIcons'
import { useLanguage } from '@/i18n/LanguageProvider'

const Footer = () => {
  const { t } = useLanguage()
  
  return (
    <footer className="bg-[#1C1C1C] border-t border-[#B9AE9A]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 items-center">
          <div className="flex items-center space-x-4 justify-start mb-4 md:mb-0">
            <Image 
              src="/logo.png" 
              alt="Pathin Logo" 
              width={100} 
              height={30} 
              className="h-8 w-auto"
            />
            <span className="text-sm font-bauhaus text-[#B9AE9A]">e.V.</span>
          </div>
          <PathinSocialIcons className="flex flex-row items-center gap-6 justify-center mb-4 md:mb-0" />
          <div className="flex space-x-8 justify-end">
            <Link to="/legal/privacy_policy_gdpr_en" className="text-sm font-bauhaus text-[#B9AE9A]/60 hover:text-[#B9AE9A] transition-colors">{t('footer.privacy')}</Link>
            <Link to="/legal/impressum_en" className="text-sm font-bauhaus text-[#B9AE9A]/60 hover:text-[#B9AE9A] transition-colors">{t('footer.imprint')}</Link>
            <Link to="/legal/terms_en" className="text-sm font-bauhaus text-[#B9AE9A]/60 hover:text-[#B9AE9A] transition-colors">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 